import { useThreadRuntime } from "@assistant-ui/react"
import { HugeiconsIcon } from "@hugeicons/react"
import {
  AiChat02Icon,
  Bug01Icon,
  SparklesIcon,
  ArrowRight01Icon,
} from "@hugeicons/core-free-icons"

/** Welcome screen shown before the user sends any message. Presents one live
 *  action (Report a problem) and a greyed placeholder hinting at future
 *  capabilities. */
export function WelcomeCards() {
  const threadRuntime = useThreadRuntime()

  const handleReportProblem = () => {
    threadRuntime.append("I'd like to report a problem")
  }

  return (
    <div className="flex flex-col items-center gap-5 px-4 py-8 text-center">
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-primary/10">
        <HugeiconsIcon icon={AiChat02Icon} size={22} className="text-primary" />
      </div>

      <div className="space-y-1">
        <h3 className="text-base font-semibold">Hi there</h3>
        <p className="text-xs text-muted-foreground">How can I help today?</p>
      </div>

      <div className="flex w-full max-w-sm flex-col gap-2">
        <button
          type="button"
          onClick={handleReportProblem}
          className="group flex items-center gap-3 rounded-xl border bg-background px-3.5 py-3 text-left ring-1 ring-border transition-all hover:bg-muted/30 hover:ring-primary/50 hover:shadow-sm cursor-pointer"
        >
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <HugeiconsIcon icon={Bug01Icon} size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold">Report a problem</p>
            <p className="text-xs text-muted-foreground">
              Walk through the issue with a few questions.
            </p>
          </div>
          <HugeiconsIcon
            icon={ArrowRight01Icon}
            size={14}
            className="shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5 group-hover:text-primary"
          />
        </button>

        <div className="flex items-center gap-3 rounded-xl border border-dashed bg-muted/20 px-3.5 py-3 text-left">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-muted text-muted-foreground">
            <HugeiconsIcon icon={SparklesIcon} size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-muted-foreground">
              More actions coming soon
            </p>
            <p className="text-xs text-muted-foreground/80">
              Ask questions, share suggestions, and more.
            </p>
          </div>
        </div>
      </div>

      <p className="text-[11px] text-muted-foreground">
        You can also just type below.
      </p>
    </div>
  )
}
